<template>
  <div id="app">
    <div>
      <!-- <bar-chart width="1000" height="200" req="ws_latency.php"/>
      <br/> -->
      <bar-chart :width="1000" :height="250" req="ws_latency_hour.php"/>
      <br/>
      <bar-chart :width="800" :height="180" req="ws_art_stats.php"/>
      <br/>
      <line-chart :width="800" :height="170" :req="jobs_meta" @click.native="changeAvgState"/>
      <br/>
      <line-chart :width="800" :height="170" :req="filter_meta" @click.native="changeAvgState1"/>
    </div>
  </div>
</template>

<script>
import LineChart from './components/LineChart.vue'
import BarChart from './components/BarChart.vue'

export default {
  name: 'app',
  components: {
    LineChart,
    BarChart
  },
  data() {
    return {
      jobs_meta: 'ws_jobs.php?q=meta&avg=1',
      filter_meta: 'ws_jobs.php?q=filter&avg=1'
    }
  },
  methods: {
    changeAvgState() {
      if (this.jobs_meta.indexOf("&avg=1") != -1) {
        this.jobs_meta = this.jobs_meta.replace("&avg=1", "");
      } else {
        this.jobs_meta += "&avg=1";
      }
      console.log(this.jobs_meta)
    },
    changeAvgState1() {
      if (this.filter_meta.indexOf("&avg=1") != -1) {
        this.filter_meta = this.filter_meta.replace("&avg=1", "");
      } else {
        this.filter_meta += "&avg=1";
      }
      console.log(this.filter_meta)
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
}
</style>
